import { IonContent, IonPage } from "@ionic/react";
import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Steps, Form, Input, Button, Alert } from "antd";

/* Global State*/
import useSignUpStore from "../states/useSignUp";
import useAuthStore from "../states/useAuth";


import c from "../utils/common";
import _ from "lodash";
import log from "../utils/log";
import { useTranslation } from "react-i18next";
import metaData from "../data/metaData";
import { showErrMsg } from "../utils/error";

//
import useAuth from "../hooks/useAuth";

const { Step } = Steps;
const QRCode = require("qrcode.react");
const speakeasy = require("speakeasy");

const TwoFa = () => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  
  const { isResetTwoFa } = useAuthStore();
  const { newUser } = useSignUpStore();
  const { createAccount, addTwoFa } = useAuth();

  const [twoFaOtpForm] = Form.useForm();
  const [twoFaStep, setTwoFaStep] = useState(1);
  const [setUpURL, setSetUpURL] = useState();
  const [secret, setSecret] = useState();
  const [isLoadingAddTwoFa, setIsLoadingAddTwoFa] = useState(false);
  const [isShowTotpWrongMsg, setIsShowTotpWrongMsg] = useState(false);

  const scroll = () => {
    let div = document.getElementById("scrollRref");
    div.scrollIntoView({ behavior: "smooth" });
  };

  const getSecret = () => {
    let _secret = speakeasy.generateSecret({ length: 20 });
    setSecret(_secret);

    log.debug(_secret.base32);
    let str = "otpauth://totp/" + t("register.description_2") + "?secret=" + _secret.base32;
    log.debug(str);
    setSetUpURL(str);
  };

  const onTwoFaOtpFormFinish = () => {
    validateTotp(twoFaOtpForm.getFieldValue("totp"));
  };

  const onTwoFaOtpFormFinishFailed = (errorInfo) => {
    //log.debug('Failed:', errorInfo);
  };

  const validateTotp = async (totp) => {
    // account has no secret
    let isValid = speakeasy.totp.verify({
      secret: secret.ascii,
      encoding: "ascii",
      token: totp,
    });

    if (isValid) {
      if (isResetTwoFa) {
        _addTwoFa();
      } else {
        signUp();
      }
    } else {
      setIsLoadingAddTwoFa(false);
      setIsShowTotpWrongMsg(true);
    }
  };

  const _addTwoFa = async () => {
    setIsLoadingAddTwoFa(true);
    try {
      await addTwoFa(secret.ascii);
      c.message({ type: "success", content: "Success" });
      history.goBack();
    } catch (error) {
      showErrMsg(error);
    } finally {
      setIsLoadingAddTwoFa(false);
    }
  };

  const signUp = async () => {
    setIsLoadingAddTwoFa(true);

    if (newUser === undefined) {
      setIsLoadingAddTwoFa(false);
      return c.message({ type: "error", content: "Please fill in your user information before proceeding" });
    }

    let data = { ...newUser, secret: secret.ascii };
    log.debug(data);

    try {
      await createAccount(data);

      setTwoFaStep(twoFaStep + 1);
    } catch (error) {
      showErrMsg(error);
    } finally {
      setIsLoadingAddTwoFa(false);
    }
  };

  return (
    <IonPage>
      <IonContent>
        <Row id="scrollRref" style={{ padding: "3vw 20vw 0vw 20vw", width: "100vw" }}>
          <h1 style={{ width: "100%", margin: 0 }}>Secure Your Account with Two-Factor Authentication (2FA)</h1>
          <p style={{ color: "var(--ion-color-step-500)", marginBottom: "3rem" }}>
            Enable 2FA to add an extra layer of protection to your account. Even if your password is compromised, 2FA
            ensures only you can access your account.
          </p>
          <Steps
            progressDot
            current={twoFaStep - 1}
            onChange={(current) => {
              setTwoFaStep(current + 1);
            }}
          >
            <Step title={t("register.step1")} />
            <Step title={t("register.step2")} />
            <Step title={t("register.step3")} />
            <Step disabled title={t("register.step4")} />
          </Steps>

          {twoFaStep == 1 ? (
            <Row>
              <Row
                align="middle"
                style={{
                  marginTop: "2.5vw",
                  fontSize: "1.5vw",
                  width: "100%",
                }}
              >
                <img
                  style={{ width: 50, height: 50 }}
                  src={metaData.blobPreURL + "google-authenticator-logo-square.jpg" + metaData.blobPostURL}
                ></img>
                &nbsp;&nbsp;{t("register.GAtitle")}
              </Row>
              <Row style={{ width: "100%" }}>
                <div
                  style={{
                    color: "red",
                    fontsize: "0.7vw",
                    margin: "1rem 0 2rem 0",
                  }}
                >
                  {t("register.withphone")}
                </div>
              </Row>
              <Row style={{ width: "100%" }}>
                <Col style={{ height: "70%", width: "50%" }}>
                  <div style={{ marginLeft: "5%", color: "#808180" }}>{t("register.LinkTitleAnd")}</div>
                  <img
                    style={{ width: 200, height: 77 }}
                    onClick={() => {
                      window.open(metaData.offical.GA.androidStore);
                    }}
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  />

                  <div style={{ margin: "5%" }}>
                    <QRCode value={metaData.offical.GA.androidStore}></QRCode>
                  </div>
                </Col>

                <Col style={{ height: "70%", width: "50%" }}>
                  <div style={{ marginLeft: "5%", color: "#808180" }}> {t("register.LinkTitleIos")}</div>
                  <img
                    style={{ width: 200, height: 77 }}
                    onClick={() => {
                      window.open(metaData.offical.GA.appleStore);
                    }}
                    src="https://www.plasticsurgery.org/resources/img/app_store/apple-app-store-badge.png"
                  />

                  <div style={{ margin: "5%" }}>
                    <QRCode value={metaData.offical.GA.appleStore}></QRCode>
                  </div>
                </Col>
              </Row>

              <Row
                style={{
                  marginTop: "2.5vw",
                  fontSize: "1.5vw",
                  width: "100%",
                }}
              >
                {t("register.step1-2")}
              </Row>

              <Row style={{ width: "100%" }}>
                <Col
                  style={{
                    height: "100%",
                    width: "50%",
                    justify: "center",
                  }}
                >
                  <div style={{ marginLeft: "5%", color: "#808180" }}>{t("register.1-2GP")}</div>
                  <Col style={{ width: "50%", justify: "center" }}>
                    <div style={{ width: 200 }} className="iphone-frame">
                      <div style={{ width: 200, height: 387, padding: 20 }}>
                        <img src={metaData.blobPreURL + "GA_GooglePlay_1.jpeg" + metaData.blobPostURL}></img>
                      </div>
                    </div>
                  </Col>
                </Col>

                <Col
                  style={{
                    height: "100%",
                    width: "50%",
                    justify: "center",
                  }}
                >
                  <div style={{ marginLeft: "5%", color: "#808180" }}>{t("register.1-2AS")}</div>
                  <Col style={{ width: "50%", justify: "center" }}>
                    <div style={{ width: 200 }} className="iphone-frame">
                      <div style={{ width: 200, height: 387, padding: 20 }}>
                        <img src={metaData.blobPreURL + "GA_AppStore_1.jpeg" + metaData.blobPostURL}></img>
                      </div>
                    </div>
                  </Col>
                </Col>
              </Row>

              <Button
                size="large"
                type="primary"
                onClick={() => {
                  scroll();
                  setTwoFaStep(twoFaStep + 1);
                }}
                style={{
                  justify: "center",
                  margin: "2rem 0 2rem",
                  width: "10rem",
                }}
              >
                {t("register.next")}
              </Button>
            </Row>
          ) : twoFaStep == 2 ? (
            <Row style={{ margin: "2vw" }}>
              <Row
                style={{
                  marginTop: "2.5vw",
                  width: "100%",
                  fontSize: "1.5vw",
                }}
              >
                {t("register.step2-1")}
              </Row>
              <Row>
                <Col>
                  <div style={{ width: 200 }} className="iphone-frame">
                    <div style={{ width: 200, height: 387, padding: 20 }}>
                      <img src={metaData.blobPreURL + "GA_phone_screencap_1.jpeg" + metaData.blobPostURL}></img>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row style={{ width: "100%" }}>
                <Row
                  style={{
                    marginTop: "2.5vw",
                    fontSize: "1.5vw",
                    width: "100%",
                  }}
                >
                  {t("register.step2-2")}
                </Row>
                <Row>
                  <Col style={{ width: "33%" }}>
                    <div style={{ width: 200 }} className="iphone-frame">
                      <div style={{ width: 200, height: 387, padding: 20 }}>
                        <img src={metaData.blobPreURL + "GA_App_1.jpeg" + metaData.blobPostURL}></img>
                      </div>
                    </div>
                  </Col>
                  <Col style={{ width: "33%" }}>
                    <div style={{ width: 200 }} className="iphone-frame">
                      <div style={{ width: 200, height: 387, padding: 20 }}>
                        <img
                          style={{
                            width: "100%",
                            height: "relative",
                          }}
                          src={metaData.blobPreURL + "GA_App_2.jpeg" + metaData.blobPostURL}
                        ></img>
                      </div>
                    </div>
                  </Col>
                  <Col style={{ width: "33%" }}>
                    <div style={{ width: 200 }} className="iphone-frame">
                      <div style={{ width: 200, height: 387, padding: 20 }}>
                        <img
                          style={{
                            width: "100%",
                            height: "relative",
                          }}
                          src={metaData.blobPreURL + "GA_App_3.jpeg" + metaData.blobPostURL}
                        ></img>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Row>

              <Row style={{ width: "100%" }}>
                <Row
                  style={{
                    marginTop: "2.5vw",
                    fontSize: "1.5vw",
                    width: "100%",
                  }}
                >
                  {t("register.step2-3")}
                </Row>
              </Row>
              <Row>
                <Col>
                  <div style={{ width: 200 }} className="iphone-frame">
                    <div style={{ width: 200, height: 387, padding: 20 }}>
                      <img src={metaData.blobPreURL + "GA_App_4.jpeg" + metaData.blobPostURL}></img>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row style={{ width: "100%", margin: "2rem 0 2rem" }}>
                <Button
                  size="large"
                  onClick={() => {
                    scroll();
                    setTwoFaStep(twoFaStep - 1);
                  }}
                  style={{ marginRight: "1rem", width: "10rem" }}
                >
                  {t("register.previous")}
                </Button>
                <Button
                  size="large"
                  type="primary"
                  onClick={() => {
                    scroll();
                    setTwoFaStep(twoFaStep + 1);
                  }}
                  style={{
                    width: "10rem",
                  }}
                >
                  {t("register.next")}
                </Button>
              </Row>
            </Row>
          ) : twoFaStep == 3 ? (
            <Row style={{ margin: "2vw" }}>
              <Row style={{ width: "100%", fontSize: "1.5vw" }}>
                <Row style={{ width: "100%" }}>
                  <Row style={{ fontSize: "1.5vw", width: "100%" }}>{t("register.step3-1")}</Row>
                </Row>

                <Row style={{ width: "100%", marginTop: 20, marginBottom: 50 }}>
                  {setUpURL ? (
                    <div style={{ fontSize: "1.5vw", color: "#1890FF" }}>
                      <QRCode style={{ width: "15vw", height: "15vw" }} value={setUpURL}></QRCode>
                    </div>
                  ) : (
                    <Button
                      size="large"
                      type="primary"
                      onClick={() => {
                        getSecret();
                      }}
                      style={{
                        width: "10rem",
                      }}
                    >
                      {t("register.step3-1generate")}
                    </Button>
                  )}
                </Row>

                <Row style={{ fontSize: "1.5vw" }}>
                  {t("register.step3-2")}
                  <Col span={16}>
                    <Form
                      style={{
                        margin: "1rem 0 5rem 0",
                        width: "100%",
                      }}
                      form={twoFaOtpForm}
                      onFinish={onTwoFaOtpFormFinish}
                      onFinishFailed={onTwoFaOtpFormFinishFailed}
                    >
                      {isShowTotpWrongMsg == true ? (
                        <Row style={{ marginBottom: "2vw" }}>
                          <Col span={20}>
                            <Alert
                              message={t("register.step3-2wrong")}
                              type="error"
                              closable
                              afterClose={() => {
                                setIsShowTotpWrongMsg(false);
                              }}
                            />
                          </Col>
                        </Row>
                      ) : null}

                      <Form.Item
                        name="totp"
                        rules={[
                          {
                            required: true,
                            min: 6,
                            max: 6,
                            message: t("register.step3-2req"),
                          },
                          {
                            pattern: /^\d+$/,
                            message: t("register.step3-2rule"),
                          },
                        ]}
                        style={{ width: "100%" }}
                      >
                        <Input size="large" maxLength={6} style={{ width: "100%" }} />
                      </Form.Item>
                    </Form>
                  </Col>
                </Row>

                <Row style={{ width: "100%", marginBottom: 50 }}>
                  {twoFaStep !== 1 ? (
                    <Button
                      size="large"
                      disabled={isLoadingAddTwoFa}
                      onClick={() => {
                        scroll();
                        setTwoFaStep(twoFaStep - 1);
                      }}
                      style={{ marginRight: "1rem", width: "10rem" }}
                    >
                      {t("register.previous")}
                    </Button>
                  ) : null}

                  <Button
                    size="large"
                    type="primary"
                    loading={isLoadingAddTwoFa}
                    onClick={() => {
                      twoFaOtpForm.submit();
                    }}
                    style={{
                      width: "10rem",
                    }}
                  >
                    {t("register.next")}
                  </Button>
                </Row>
              </Row>
            </Row>
          ) : twoFaStep == 4 ? (
            <Row
              style={{
                width: "100%",
                fontSize: "2rem",
                color: "black",
              }}
            >
              <Row justify="center" style={{ width: "100%", fontSize: "1.5rem", marginBottom: "4rem 0 2rem 0" }}>
                {t("register.CompleteAC")}
              </Row>

              <Row justify="center" style={{ width: "100%" }}>
                <Col>
                  <Button
                    type="primary"
                    size="large"
                    onClick={() => {
                      // Perform actions after successful sign-up
                      history.push({ pathname: "/get-started" });
                    }}
                    style={{
                      width: "10rem",
                      marginTop: "3rem",
                    }}
                  >
                    {t("register.EnterDash")}
                  </Button>
                </Col>
              </Row>
            </Row>
          ) : null}

          <Row style={{ height: "5rem" }}></Row>
        </Row>
      </IonContent>
    </IonPage>
  );
};

export default TwoFa;
